import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalWhereDoIRegisterPage } from 'src/app/model/page/group/iag-portal/iag-portal-where-do-i-register';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-where-do-i-register-page',
  templateUrl: './iag-portal-where-do-i-register-page.component.html',
  styleUrls: ['./iag-portal-where-do-i-register-page.component.scss']
})
export class IagPortalWhereDoIRegisterPageComponent implements OnInit {
  iagPortalWhereDoIRegisterPage: IagPortalWhereDoIRegisterPage = {} as IagPortalWhereDoIRegisterPage;

  pageName = 'Where do I register?';
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-register') {
        this.iagPortalWhereDoIRegisterPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalWhereDoIRegisterPage.sections = [];
    this.iagPortalWhereDoIRegisterPage.whereDoIRegisterCards = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((iagPortalWhereDoIRegisterPageEntries) => {
      this.mapBanner(iagPortalWhereDoIRegisterPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalWhereDoIRegisterPage.banner);
      this.mapPageInfo(iagPortalWhereDoIRegisterPageEntries.items);
      this.mapSections(iagPortalWhereDoIRegisterPageEntries.includes.Entry);
      this.mapCards(iagPortalWhereDoIRegisterPageEntries.includes.Entry);
    });
  }

  private mapBanner(iagPortalWhereDoIRegisterPageEntries: Entry<any>[]) {
    iagPortalWhereDoIRegisterPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];

    this.iagPortalWhereDoIRegisterPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string
     
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalWhereDoIRegisterPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalWhereDoIRegisterPage.banner.url = entry.fields?.url;
      this.iagPortalWhereDoIRegisterPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalWhereDoIRegisterPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalWhereDoIRegisterPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalWhereDoIRegisterPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalWhereDoIRegisterPageEntries: Entry<any>[]) {
    iagPortalWhereDoIRegisterPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();


    this.iagPortalWhereDoIRegisterPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapCards(iagPortalWhereDoIRegisterPageEntries: Entry<any>[]) {
    iagPortalWhereDoIRegisterPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .filter((entry) => entry.fields['headImage'])
      .forEach((entry) => {
        this.mapEntryToUseNDCCards(entry);
      });
  }

  private mapEntryToUseNDCCards(entry: Entry<any>) {
    let headImage:any = entry.fields['headImage'] as string;
    let body: any = entry.fields['body'] as string
    this.iagPortalWhereDoIRegisterPage.whereDoIRegisterCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      headImage: headImage?.fields?.file?.url,
      body: body.content[0].content[0].value,
      buttonText: entry.fields['buttonText'] as string,
      buttonUrl: entry.fields['buttonUrl'] as string
    });
    this.iagPortalWhereDoIRegisterPage.whereDoIRegisterCards.sort((a, b) => a.order - b.order);
  }
}
